type CreditCardSVGTypes = {
  color?: string;
};

const CreditCardSVG = ({ color }: CreditCardSVGTypes) => {
  return (
    <svg
      width="25"
      height="16"
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.745235 1.22852C0.542432 1.62655 0.507342 2.1263 0.50127 3H24.4987C24.4927 2.1263 24.4576 1.62655 24.2548 1.22852C24.039 0.805157 23.6948 0.46095 23.2715 0.245235C22.7902 0 22.1601 0 20.9 0H4.1C2.83988 0 2.20982 0 1.72852 0.245235C1.30516 0.46095 0.96095 0.805157 0.745235 1.22852ZM24.5 6H0.5V12.4C0.5 13.6601 0.5 14.2902 0.745235 14.7715C0.96095 15.1948 1.30516 15.539 1.72852 15.7548C2.20982 16 2.83988 16 4.1 16H20.9C22.1601 16 22.7902 16 23.2715 15.7548C23.6948 15.539 24.039 15.1948 24.2548 14.7715C24.5 14.2902 24.5 13.6601 24.5 12.4V6ZM2.49992 12H8.49992V14H2.49992V12Z"
        fill={color || '#717888'}
      />
    </svg>
  );
};

export default CreditCardSVG;
